const enableNode = document.querySelector( '#wcbt_wishlist_enable' );
const enableToolTipNode = document.querySelector( '#wcbt_wishlist_tooltip_enable' );
const tooltipTextNode = document.querySelector( '#wcbt_wishlist_tooltip_text' );
const removeTooltipTextNode = document.querySelector( '#wcbt_wishlist_remove_tooltip_text' );

const wcbtWishList = () => {
	enableField();
};

const enableField = () => {
	if ( ! enableNode ) {
		return;
	}

	handle( enableNode );
	enableNode.addEventListener( 'change', function( event ) {
		handle( this );
	} );
};

const handle = ( enableNode ) => {
	const fieldWrapperNodes = document.querySelectorAll( '.wcbt-field-wrapper' );

	if ( ! fieldWrapperNodes ) {
		return;
	}
	const enableFieldWrapperNode = enableNode.closest( '.wcbt-field-wrapper' );
	for ( let i = 0; i < fieldWrapperNodes.length; i++ ) {
		const fieldWrapperNode = fieldWrapperNodes[ i ];
		if ( fieldWrapperNode === enableFieldWrapperNode ) {
			continue;
		}

		if ( enableNode.checked ) {
			fieldWrapperNode.style.display = 'flex';
			enableToolTip();
		} else {
			fieldWrapperNode.style.display = 'none';
		}
	}
};

const handleEnableTooltip = ( enableToolTipNode ) => {
	if ( ! tooltipTextNode || !removeTooltipTextNode) {
		return;
	}

	const tooltipTextField = tooltipTextNode.closest( '.wcbt-field-wrapper' );
	const removeTooltipTextField = removeTooltipTextNode.closest( '.wcbt-field-wrapper' );

	if ( enableToolTipNode.checked ) {
		tooltipTextField.style.display = 'flex';
		removeTooltipTextField.style.display = 'flex';
	} else {
		tooltipTextField.style.display = 'none';
		removeTooltipTextField.style.display = 'none';
	}
};

const enableToolTip = () => {
	if ( ! enableToolTipNode ) {
		return;
	}

	handleEnableTooltip( enableToolTipNode );
	enableToolTipNode.addEventListener( 'change', function( event ) {
		handleEnableTooltip( this );
	} );
};

export default wcbtWishList;
